import { IProjectDetails } from "../../types/interfaces";
import AppDatabase from "../InitialiseDatabase";

export default class ProjectHandler {
  DB: AppDatabase
  constructor() {
    this.DB = new AppDatabase()
  }
  async CreateProject(ProjectData: IProjectDetails) {
    await this.DB.projects.add(ProjectData)
  }
  async UpdateProject(filterKey: number, updateObj:IProjectDetails) {
    await this.DB.projects.update(filterKey,updateObj)
    return await this.DB.projects.get(filterKey)
  }
  async DeleteProject(filterKey:number) {
    const project = await this.DB.projects.get(filterKey)
    if (project) {
      await this.DB.todos.where("project").equals(project?.projectName).delete()
      await this.DB.schedules.where("project").equals(project?.projectName).delete()
      await this.DB.notes.where("project").equals(project?.projectName).delete()
      await this.DB.notesFolder.where("project").equals(project?.projectName).delete()
    }
    await this.DB.projects.delete(filterKey)
  }
  
  async FetchProjects() {
    return await this.DB.projects.toArray()
  }
}